// Styles
import './information-icons.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initInformationIcons = (context) => {
  const informationIconsSection = context.closest('.shopify-section');

  if (informationIconsSection) {
    new Swiper(informationIconsSection.querySelector('.information-icons__container'), {
      loop: true,
      slidesPerView: 1,
      pagination: {
        el: informationIconsSection.querySelector('.information-icons__dots'),
        clickable: true
      },
      centerInsufficientSlides: true,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 16
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 40
        }
      }
    });
  }
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.information-icons__container'), (el) => {
    window.dAgency.initInformationIcons(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.information-icons__container'), (el) => {
      window.dAgency.initInformationIcons(el);
    });
  });
}
